// Чеки «Мой налог» и напоминания клиенту.
import { addMonths, daysInMonth, monthOf, pad2 } from './dates.ts';

export const RECEIPT = { NEED: 'need', DONE: 'done', NO: 'no' } as const;
export type Receipt = typeof RECEIPT[keyof typeof RECEIPT];
export const RECEIPT_LABEL: Readonly<Record<Receipt, string>> = { need: 'нужен', done: 'выбит', no: 'не нужен' };

// Срок чека: такое-то число следующего месяца (по закону — 9-е).
export function receiptDue(paymentDate: string, dueDay: number): string {
  const ym = addMonths(monthOf(paymentDate), 1);
  return ym + '-' + pad2(Math.min(Number(dueDay) || 9, daysInMonth(ym)));
}

// Нужен ли чек: рубли, источник отмечен «В Мой налог», и это не проект, который выбивает чек сам.
// mytax у самой оплаты (true/false) главнее отметки источника.
export function receiptNeeded(payment: { cur: string; source?: string | null; mytax?: boolean | null },
  sourcesMyTax: Readonly<Record<string, boolean>>, groupSelfReceipt: boolean): boolean {
  if (payment.cur !== 'RUB') return false;
  if (payment.mytax === false) return false;
  if (payment.mytax === true) return !groupSelfReceipt;
  if (!sourcesMyTax[payment.source ?? '']) return false;
  return !groupSelfReceipt;
}

// Подстановки в тексте напоминания: {имя} {когда} {пояс} {ссылка} {адрес}. Незнакомые остаются как есть.
export function fillTemplate(t: string | null | undefined, vars: Readonly<Record<string, string>>): string {
  return String(t ?? '').replace(/\{([^{}]+)\}/g, (m, k: string) => vars[k.trim()] ?? m);
}

export function waLink(phone: string | null | undefined, text: string): string {
  return 'https://wa.me/' + String(phone ?? '').replace(/[^\d]/g, '') + '?text=' + encodeURIComponent(text);
}

export function tgLink(user: string | null | undefined, text?: string): string {
  return 'https://t.me/' + String(user ?? '').replace(/^@/, '') + (text ? '?text=' + encodeURIComponent(text) : '');
}
